import styled, { css, keyframes } from 'styled-components'
import { UIInput, UIText } from 'components'

import { TInputStyledContent } from './types'

const inputBorderColor = ({ hasError, isPlaceHolder }: TInputStyledContent) => {
  if (hasError) return 'var(--error500)'
  if (isPlaceHolder) return 'var(--gray200)'
  return 'var(--primary500)'
}
const inputTextColor = ({ hasError, isPlaceHolder }: TInputStyledContent) => {
  if (isPlaceHolder) return 'var(--typography200)'
  if (hasError) return 'var(--error500)'
  return 'var(--typography500)'
}

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 24px 0 12px 0;
  flex-direction: column;
`

export const InputHidden = styled(UIInput)`
  position: absolute;
  top: 50px;
  font-size: 8px;
  opacity: 0;
  input {
    width: 80px;
  }
`

export const InputStyled = styled.div`
  display: flex;
  justify-content: center;
  font-family: Sora;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 10px;
`

export const InputStyledContent = styled.div<TInputStyledContent>`
  width: 42px;
  margin: 0 6px;
  text-align: center;
  border-bottom: 2px solid ${inputBorderColor};
  color: ${inputTextColor};

  ${({ isFocused, isPlaceHolder }) =>
    isFocused &&
    css`
      &:after {
        content: '';
        width: 2px;
        height: 45px;
        position: absolute;
        background-color: var(--primary500);
        animation: ${carretKeyFrames} 1s infinite;
        ${isPlaceHolder && 'margin-left: -13px;'}
      }
    `}
`
const carretKeyFrames = keyframes`
  from {background-color: var(--primary500);}
  to {background-color: transparent;}
`

export const InfoError = styled(UIText)`
  color: var(--error500) !important;
  text-align: center;
`
